<template>
  <CRow>
    <CCol col="12" md="12">
      <CCard style="top: 10px">
        <CCardHeader>
          <p>
            <DatePicker
              v-model="value1"
              type="date"
              range
              placeholder="Select date range"
              style="float: left"
            ></DatePicker>

            <CButton
              block
              class="mx-2"
              color="success"
              style="float: right; width: 200px"
              @click="goToEsportsgameForm()"
            >
              <i class="fa fa-plus" aria-hidden="true"></i> Add Esports
              Game</CButton
            >

            <!-- <CButton
              block
              color="success"
              style="float: right; width: 150px"
              @click="wizard()"
            >
              <i class="fa fa-plus" aria-hidden="true"></i> Add new</CButton
            > -->
          </p>
        </CCardHeader>
        <CCardBody>
          <CDataTable
            pagination
            clickable-rows
            hover
            :fields="fields"
            :items="tableData"
          >
            <template #gameImage="{ item }">
              <td>
                <img :Src="item.gameImage" class="icon" />
              </td>
            </template>
            <template #Action="{ item }">
              <td>
                <CButton
                color="primary"
                style="width: 120px"
                @click="paidToken(item)"
                >Create Paid</CButton
              > &nbsp;
              <CButton
                color="warning"
                style="width: 120px"
                @click="freeToken(item)"
                >Create Free</CButton
              >
              </td>
            </template>
          </CDataTable>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import CTableWrapper from "../tables/Table";
import firebase from "firebase";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
const db = firebase.firestore();
export default {
  components: { CTableWrapper, DatePicker },
  data() {
    return {
      value1: [],
      tableData: [],
      fields: [
        {
          label: "created",
          key: "created",
          sortable: true,
        },
        {
          label: "Icon",
          key: "gameImage",
          sortable: true,
        },
        {
          label: "GameName",
          key: "GameName",
          sortable: true,
        },

        {
          key: "Action",
          sortable: true,
        },
      ],
    };
  },
  watch: {
    value1() {
      var res = new Date(this.value1[1]);
      res.setDate(res.getDate() + 1);

      let v1 = firebase.firestore.Timestamp.fromDate(new Date(this.value1[0]));
      let v2 = firebase.firestore.Timestamp.fromDate(new Date(res));

      db.collection("esportsGames")
        .where("gameUploadDate", ">=", v1)
        .where("gameUploadDate", "<=", v2)
        .orderBy("gameUploadDate", "desc")
        .get()
        .then((snapshot) => {
          this.tableData = [];
          snapshot.forEach((doc) => {
            this.tableData.push(this.assignsmallData(doc));
          });

          this.loading = false;
        });
    },
  },
  methods: {
    wizard() {
      this.$router.push({ name: "gameForm" });
    },
    goToEsportsgameForm() {
      this.$router.push({ name: "EsportsgameForm" });
    },
    paidToken(item) {
      console.log("item", item);
      this.$router.push({
        name: "esportsTournamentList",
        params: {
          id: item.id,
          gameName: item.GameName,
          gameImage: item.gameImage,
          coverImage: item.coverImage,
          featureCover:item.featureCover
        },
      });
    },
    freeToken(item) {
      console.log("item", item);
      this.$router.push({
        name: "freeEsports",
        params: {
          id: item.id,
          gameName: item.GameName,
          gameImage: item.gameImage,
          coverImage: item.coverImage,
          featureCover:item.featureCover
        },
      });
    },
    editToken(item) {
      this.$router.push({
        name: "esportsTournamentList",
        params: {
          id: item.id,
          gameName: item.GameName,
          gameImage: item.gameImage,
          coverImage: item.coverImage,
          featureCover:item.featureCover
        },
      });
    },
    async gettokens() {
      this.tableData = [];

      // var startOfToday = new Date();
      // startOfToday.setHours(0, 0, 0, 0);
      // var endOfToday = new Date();
      // endOfToday.setHours(23, 59, 59, 999);

      try {
        await db
          .collection("esportsGames")
          // .where("gameUploadDate", ">=", startOfToday)
          // // .where("gameUploadDate", "<=", endOfToday)
          // .orderBy("gameUploadDate", "desc")
          .get()
          .then((snapshot) => {
            this.tableData = [];
            snapshot.forEach((doc) => {
              this.tableData.push(this.assignsmallData(doc));
            });
          });
      } catch (error) {}
    },
    assignsmallData(doc) {
      let smallDocument = {
        id: doc.id,
        GameName: doc.data().gameName,
        gameImage: doc.data().gameImage,
        coverImage: doc.data().coverImage,
        featureCover: doc.data().featureCover,
        created: moment(doc.data().created.seconds * 1000).format("DD-MM-YYYY"),
      };
      return smallDocument;
    },
  },
  created() {
    this.gettokens();
  },
};
</script>

<style>
.icon {
  width: 50px;
  height: 50px;
  border-radius: 50px;
}
</style>
